// ============================================
// Canvas Slice - управление zoom и pan canvas
// ============================================

import { StateCreator } from 'zustand';

export interface CanvasState {
  // Canvas state
  canvasZoom: number;
  canvasPan: { x: number; y: number };
  
  // Canvas actions
  setCanvasZoom: (zoom: number) => void;
  resetCanvasZoom: () => void;
  setCanvasPan: (x: number, y: number) => void;
  resetCanvasView: () => void;
}

export const createCanvasSlice: StateCreator<CanvasState, [], [], CanvasState> = (set) => ({
  // Initial state
  canvasZoom: 1,
  canvasPan: { x: 0, y: 0 },
  
  // Set canvas zoom
  setCanvasZoom: (zoom: number) => {
    const clampedZoom = Math.max(0.5, Math.min(5.0, zoom));
    set({ canvasZoom: clampedZoom });
  },
  
  // Reset canvas zoom
  resetCanvasZoom: () => {
    set({ canvasZoom: 1, canvasPan: { x: 0, y: 0 } });
  },
  
  // Set canvas pan
  setCanvasPan: (x: number, y: number) => {
    set({ canvasPan: { x, y } });
  },
  
  // Reset canvas view (zoom and pan)
  resetCanvasView: () => {
    set({ canvasZoom: 1, canvasPan: { x: 0, y: 0 } });
  }
});
